export function getDocument(data) {
    let { getDocumentRequest, getDocumentError, getDocumentResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'app/document/get_document',
        this.createBundle('app/document/get_document', { id: data }, this.GET, getDocumentRequest, getDocumentResult, getDocumentError)
    )
}
